import { ApiModel } from './api-model';

export class Channel extends ApiModel {

  id: number;
  longName: string;
  value: string;
  isMain: boolean;
  isLinear: boolean;
  isBeam: boolean;
  isBT: boolean;
  isLE: boolean;
  isLEXT: boolean;
  isMIPL: boolean;
  isTL: boolean;

  constructor(data: any) {
    super(data);
    this.isLinear = this.isMain;
    this.isBeam = this.id >= 136100 && this.id <= 136199;
    this.isBT = this.id >= 505 && this.id <= 599;
    this.isLE = this.id >= 20001 && this.id <= 20112;
    this.isLEXT = this.id >= 21001 && this.id <= 21050;
    this.isMIPL = this.id >= 30001 && this.id <= 30032;
    this.isTL = this.id >= 30101 && this.id <= 30109;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/channel.ts